export default "__VITE_ASSET__f0969553__"